import React from 'react';
import StepLayout from '../components/StepLayout';
import { isUKSeller } from '../utils/sellerRegion';

// iter-26: rebuild — Requirements page per spec.
// Two issues fixed: icon alignment (icons now perfectly centered in their
// boxes via flex centering on the box itself; rows align icon-and-text
// on a shared center line) and mobile fit (full page including
// Trustpilot occupies <844px on a 390-wide viewport).
//
// Mobile-only sizing changes are applied via the .step-compact-mobile
// wrapper class + @media overrides in takeover.css. Desktop unchanged.
export default function StepValueProp({ sessionData, onNext }) {
  const isUK = isUKSeller(sessionData);
  const symbol = isUK ? '£' : '$';
  const annual = isUK ? '£150' : '$150';

  return (
    <StepLayout title="" variant="centered">
      <div className="value-prop step-compact-mobile">
        {/* Takes 2 minutes pill */}
        <div className="vp-pill">
          <span aria-hidden="true">⏱</span>
          Takes 2 minutes
        </div>

        {/* Hero amount */}
        <div className="vp-hero">
          <h1 className="vp-hero-amount">{symbol}20</h1>
          <p className="vp-hero-sub">for 2 minutes of your time</p>
        </div>

        {/* Annual highlight */}
        <div className="vp-highlight">
          <span aria-hidden="true">📈</span>
          <span>The average person makes over {annual}/year with us</span>
        </div>

        {/* Requirements */}
        <div className="vp-requirements">
          <p className="vp-req-label">Requirements</p>
          <div className="vp-req-list">
            <div className="vp-req-row">
              <span className="vp-req-icon" aria-hidden="true">
                <span style={{ fontWeight: 600 }}>in</span>
              </span>
              <span className="vp-req-text">
                <strong>A LinkedIn profile</strong> created over 6 months ago
              </span>
            </div>
            <div className="vp-req-row">
              <span className="vp-req-icon" aria-hidden="true">💬</span>
              <span className="vp-req-text">
                <strong>Responsive on SMS or WhatsApp</strong> when we message you
              </span>
            </div>
            <div className="vp-req-row">
              <span className="vp-req-icon" aria-hidden="true">🪪</span>
              <span className="vp-req-text">
                <strong>A valid ID</strong> (passport or driver&rsquo;s license)
              </span>
            </div>
          </div>
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={onNext}
          className="vp-cta primary-cta"
        >
          I meet the requirements <span aria-hidden="true">→</span>
        </button>
      </div>
    </StepLayout>
  );
}
